import { useStaticQuery, graphql } from "gatsby"

export const useMicroCopyEn = () => {
  const { allContentfulMikroTeksti } = useStaticQuery(
    graphql`
      query microCopyEn {
        allContentfulMikroTeksti (filter: { node_locale: { eq: "en" } }) {
          edges {
            node {
              key
              value {
                value
              }
            }
          }
        }
      }
    `
  )
  return allContentfulMikroTeksti.edges
}
